import React, { useState } from "react";
import Payment from "./Payment";
import SecoundaryReportCard from '../../components/common/secoundaryReportCard';
import PersonImg from "../../assets/images/person.svg";
import Balance from "../../assets/images/balance.svg";
import PaidImg from "../../assets/images/paidAmount.svg";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { formatNumber } from "../../utils/utils";
import { InvoiceListWithoutPatientColumns } from "../../utils/serviceData";

export default function PaymentDetails({ patientVisitId, patientId }) {
  const [invoiceDetails, setPatientInvoiceDetails] = useState({});

  return (
    <div>
      <div>
        <SecoundaryReportCard
          reportList={[
            {
              title: "Total Amount",
              count: `${(invoiceDetails?.totalAmount? formatNumber(invoiceDetails?.totalAmount): 0)}`,
              icon: PersonImg,
            },
            {
              title: "Paid",
              count: `${(invoiceDetails?.paid? formatNumber(invoiceDetails?.paid): 0)}`,
              icon: PaidImg,
            },
            {
              title: "Balance",
              count: `${(invoiceDetails?.balance? formatNumber(invoiceDetails?.balance): 0)}`,
              icon: Balance,
            },
          ]}
        />
      </div>
      <div>
        <Payment
          api={API_ENDPOINTS.GET_ALL_COLLECTABLE_PAYMENTS}
          accordion
          noRequired={[
            "payment_categories",
            "patient_id",
            "patient_name",
            "patient_code",
            "collectable_payment_description_id"
          ]}
          patientId={patientId}
          setPatientInvoiceDetails = {setPatientInvoiceDetails}
          defaultColumns={InvoiceListWithoutPatientColumns}
          headerAlias={{
            collectable_payment_description_id: "invoice",
            InvoiceDate: "Date",
            total_collectable_amount: "total_amount",
            total_paid_amount: "amount_paid",
            total_balance_amount: "balance",
            invoice_code:"invoice_id"
          }}
          requiredButton={["Edit", "Add Payment", "invoice/print"]}
        />
      </div>
    </div>
  );
}
